'use client'

import { useMemo } from 'react'

import { useShallow } from 'zustand/react/shallow'

import { selectTimeRangeSelection } from '@apps/service-map/stores/service-map.selector'
import { useServiceMapStore } from '@apps/service-map/stores/service-map.store'
import type { ResolvedGatewayTimeFilter } from '@modules/gateways'
import { resolveGatewayTimeFilterFromPreset } from '@modules/gateways/utils/resolveGatewayTimeFilter'

export function useServiceMapGatewayTimeFilter(): ResolvedGatewayTimeFilter {
  const { timeRangeValue, customRangeApplied } = useServiceMapStore(useShallow(selectTimeRangeSelection))

  return useMemo(
    () => resolveGatewayTimeFilterFromPreset(timeRangeValue, customRangeApplied),
    [timeRangeValue, customRangeApplied]
  )
}
